module.exports = __webpack_public_path__ + "assets/img/2b0e0ff970e27f179e03f96e6d2735a1.png";